import cntl from "cntl";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useMemo, useEffect, useState } from "react";
import Checkbox from "./Checkbox";

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  supportingText: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md]),
};

function TileCheckbox({
  id,
  name,
  size,
  label,
  value,
  onClick,
  isChecked,
  isDisabled,
  supportingText,
}) {
  const [fontStyle, setFontStyle] = useState("");
  const [isRadioChecked, setIsRadioChecked] = useState(isChecked);

  useEffect(() => {
    setIsRadioChecked(isChecked);
  }, [isChecked]);

  const disabledUnchecked = () => cntl`
    bg-grey-50
    border-grey-200
    pointer-events-none
  `;

  const disabledChecked = () => cntl`
    bg-grey-50
    border-grey-200
    pointer-events-none
  `;

  const checked = () => cntl`
    bg-primary-25
    border-primary-300
  `;

  const unchecked = () => cntl`
    bg-white
    border-grey-200
  `;

  const wrapperCn = () => cntl`
    pl-4
    flex
    flex-row
    border
    rounded-lg 
    hover:border-primary-300
    focus-within:outline
    focus-within:outline-4
    focus-within:outline-primary-100
    ${fontStyle}
    ${
      isRadioChecked
        ? !isDisabled
          ? checked()
          : disabledChecked()
        : isDisabled
        ? disabledUnchecked()
        : unchecked()
    }
  `;

  const inputCn = () => cntl`
    mt-4
  `;

  const labelWrapperCn = () => cntl`
    flex
    flex-col
    w-full
    p-4
  `;

  const labelCn = () => cntl`
    text-grey-700
    first-letter:uppercase
    ${!!supportingText?.length ? cntl`font-medium` : cntl`font-regular`}
  `;

  const supportingTextCn = () => cntl`
    text-grey-500
    first-letter:uppercase
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setFontStyle("text-sm");
        break;
      case SIZE.md:
        setFontStyle("text-base");
        break;
      default:
        setFontStyle("text-sm");
        break;
    }
  }, [size]);

  const onChange = (e) => {
    onClick(value);
    setIsRadioChecked(e.target.checked);
  };

  return (
    <div className={wrapperCn()}>
      <Checkbox
        id={id}
        name={name}
        size={size}
        value={value}
        className={inputCn()}
        isDisabled={isDisabled}
        isChecked={isRadioChecked}
        onChange={(e) => onChange(e)}
      />
      <label htmlFor={id} className={labelWrapperCn()}>
        {!!label?.length && <span className={labelCn()}>{label}</span>}
        {!!supportingText?.length && (
          <span className={supportingTextCn()}>{supportingText}</span>
        )}
      </label>
    </div>
  );
}

TileCheckbox.propTypes = propTypes;
export default TileCheckbox;
